export default "__VITE_ASSET__59d9355d__"